import { render, staticRenderFns } from "./ProductDetailBase.vue?vue&type=template&id=4120709a&scoped=true"
import script from "./ProductDetailBase.vue?vue&type=script&lang=js"
export * from "./ProductDetailBase.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailBase.vue?vue&type=style&index=0&id=4120709a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4120709a",
  null
  
)

export default component.exports